import React from 'react'

// Components
import ProductListWithTitleAndPaginationComponent from '~/components/ProductListWithTitleAndPagination'

const CategoryComponent = ({
  page,
  categoryName,
  ...restProps
}) => (
  <ProductListWithTitleAndPaginationComponent
    {...restProps}
    {...{page}}
    headTitle={`${categoryName} - trang ${page}`}
    mainTitle={(
      <>
        <span className='green'>{categoryName}</span>
        {page > 1 && ` - trang ${page}`}
      </>
    )}
  />
)

export default CategoryComponent
